import { useEffect, useMemo } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore } from '@lib/store';
import { useRouteHook, useTabs } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { AccountType } from '@shared/api';
import { ReportDepositTab, ReportCreditTab } from './widgets';
import { PageContainer } from '@widgets';
import { NoData, Spinner, Tabs } from '@shared/widgets';

export const ReportsPage = () => {
  const { navigate } = useRouteHook();

  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const tabsState = useTabs({ withDebitCard: true });
  const { t } = useTranslation('reports');

  useEffect(() => {
    if (!profileFeatureStore.data?.reports?.viewReportsSection) navigate(RoutePaths.dashboard.onNavigate());
  }, []);

  const currentTabView = useMemo(() => {
    if (tabsState.loading) return <Spinner />;
    if (tabsState.tab === AccountType.Payment) return <ReportDepositTab />;
    else if (tabsState.tab === AccountType.Card) return <ReportCreditTab />;
    else return <NoData />;
  }, [tabsState.loading, tabsState.tab]);
  return (
    <PageContainer title={t('title')} header={t('header')}>
      {!tabsState.loading && tabsState.tabs.length > 1 && <Tabs options={tabsState.tabs} value={tabsState.tab!} onChange={tabsState.onChangeTab} />}
      {currentTabView}
    </PageContainer>
  );
};
